import { useState } from 'react';
import { type DrawerMenuItem, type NavItemNoIcon } from '@cx-web/domain-types';

import DesktopStateDropdown from './components/DesktopDropdown';
import DesktopStateDropdownLegacy from './components/DesktopDropdownLegacy';
import MobileDropDown from './components/MobileDropdown';

function StateDropdown({
  firstLevelNav,
  isUkStyle = false,
  mobileHamburgerNav,
  onStateChange,
  selectedState: initialSelectedState = '',
  stateOptions = [],
}: {
  firstLevelNav: NavItemNoIcon[];
  // When true: new animated click-based DesktopDropdown. When false (default): legacy CSS hover-based variant.
  isUkStyle?: boolean;
  mobileHamburgerNav: DrawerMenuItem[];
  onStateChange?: (state: string) => void;
  selectedState?: string;
  stateOptions?: Array<{ code: string; label: string }>;
}) {
  const [selectedState, setSelectedState] = useState(initialSelectedState);

  if (!stateOptions.length) return null;

  const setSelectedSubdivision = (newState: string) => {
    setSelectedState(newState);
    onStateChange?.(newState);
  };

  // dropdown display set in css for hydration reasons
  return (
    <>
      <MobileDropDown
        mobileHamburgerNav={mobileHamburgerNav}
        selectedState={selectedState}
        setSelectedState={setSelectedSubdivision}
        stateOptions={stateOptions}
      />
      {isUkStyle ? (
        <DesktopStateDropdown
          firstLevelNav={firstLevelNav}
          selectedState={selectedState}
          setSelectedState={setSelectedSubdivision}
          stateOptions={stateOptions}
        />
      ) : (
        <DesktopStateDropdownLegacy
          firstLevelNav={firstLevelNav}
          selectedState={selectedState}
          setSelectedState={setSelectedSubdivision}
          stateOptions={stateOptions}
        />
      )}
    </>
  );
}

export default StateDropdown;
